var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    on: {
      "click": _vm.calculate_progress,
      "keydown": function ($event) {
        return _vm.progressbar.userKeyDown();
      },
      "keyup": function ($event) {
        return _vm.progressbar.userKeyUp();
      }
    }
  }, [_c('h3', {
    staticClass: "mx-5 mt-5 mb-15 md:mx-15 md:mt-15 2xl:mx-20 2xl:mt-20 2xl:mb-20"
  }, [_vm._v("\n    Parcours\n  ")]), _vm._v(" "), _vm.$can(_vm.infosPage.name_page + '_edit', _vm.infosPass.id_pass) ? _c('div', {
    staticClass: "w-max-content w-max cursor-pointer text-gray-900 hover:text-gray-600 relative mx-5 md:mx-15 2xl:mx-20"
  }, [_c('add-button', {
    attrs: {
      "id": "add-parcours",
      "libelle": "Ajouter un parcours",
      "with-dropdown": true
    },
    on: {
      "add": _vm.displayDropdownMenu
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "ease-out duration-150",
      "enter-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
      "enter-to-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-active-class": "ease-in duration-200",
      "leave-class": "opacity-100 translate-y-0 sm:scale-100",
      "leave-to-class": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    }
  }, [_vm.dropDownMenu ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.forceHide,
      expression: "forceHide"
    }],
    staticClass: "z-20 absolute left-20 mt-1 w-max-content w-max ml-auto rounded-md bg-white shadow-md shadow-gray-600 text-sm font-normal"
  }, [_c('div', {
    staticClass: "mx-5 my-3 text-left"
  }, _vm._l(_vm.typeParcours, function (type, index) {
    return _c('div', {
      key: index,
      staticClass: "cursor-pointer first:pt-3 last:pb-3 pb-1 text-gray-600 hover:text-gray-900",
      on: {
        "click": function ($event) {
          return _vm.addItem('parcours', type);
        }
      }
    }, [_vm._v("\n            " + _vm._s(type) + "\n          ")]);
  }), 0)]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), _vm.form.parcours.length > 0 || this.otherParcours.length > 0 ? _c('div', [_c('list-grid', {
    ref: "listParcours",
    attrs: {
      "list-items": _vm.sortedParcours,
      "grid": "grid-cols-11 md:grid-cols-12",
      "is-accordion-items": true
    },
    on: {
      "displayNum": function (num) {
        _vm.parcoursDisplayed = num;
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "col-start-2 col-span-5 md:col-start-2 md:col-span-3"
        }, [_vm._v("\n          Période\n        ")]), _vm._v(" "), _c('div', {
          staticClass: "hidden md:block md:col-span-4"
        }, [_vm._v("\n          Type de parcours\n        ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-5 md:col-span-4"
        }, [_vm._v("\n          Intitulé\n        ")])];
      },
      proxy: true
    }, {
      key: "accordionDescription",
      fn: function (_ref) {
        var item = _ref.item,
          num = _ref.num;
        return [_c('icon', {
          staticClass: "text-pink-600 col-span-1 justify-self-end md:justify-self-center transform transition-transform ease-in-out duration-300",
          class: {
            'rotate-90': _vm.parcoursDisplayed === num
          },
          attrs: {
            "name": "chevron-right"
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "col-span-5 md:col-span-3 text-sm md:text-base flex items-center space-x-1 md:space-x-2"
        }, [item.projet ? _c('span', {}, [_c('info-bulle', {
          attrs: {
            "libelle": "Ce parcours est ajouté depuis la partie projet du plan d'accompagnement. Pour toutes modifications ou suppressions passer par l'onglet Projet",
            "hoverable": "",
            "name": item.projet + num
          }
        })], 1) : _vm._e(), _vm._v(" "), item.value.debut_parcours ? _c('span', [_vm._v("\n            " + _vm._s(('0' + new Date(item.value.debut_parcours).getDate()).slice(-2)) + "/" + _vm._s(('0' + (new Date(item.value.debut_parcours).getMonth() + 1)).slice(-2)) + "/" + _vm._s(new Date(item.value.debut_parcours).getFullYear()) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("-")]), _vm._v(" "), item.value.debut_parcours && !item.value.fin_parcours ? _c('span', [_vm._v("En cours")]) : _vm._e(), _vm._v(" "), item.value.fin_parcours ? _c('span', [_vm._v("\n            " + _vm._s(('0' + new Date(item.value.fin_parcours).getDate()).slice(-2)) + "/" + _vm._s(('0' + (new Date(item.value.fin_parcours).getMonth() + 1)).slice(-2)) + "/" + _vm._s(new Date(item.value.fin_parcours).getFullYear()) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "md:col-span-4 hidden md:block"
        }, [_c('tag', {
          attrs: {
            "libelle": item.type,
            "theme-color": _vm.typeTheme(item.type)
          }
        })], 1), _vm._v(" "), _c('div', {
          staticClass: "col-span-5 md:col-span-4 text-sm italic line-clamp-2 mr-5"
        }, [_vm._v("\n          " + _vm._s(item.value.intitule_parcours) + "\n        ")])];
      }
    }, {
      key: "accordionContent",
      fn: function (_ref2) {
        var item = _ref2.item,
          num = _ref2.num;
        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.parcoursDisplayed === num,
            expression: "parcoursDisplayed === num"
          }],
          key: 'formation_initiale' + num
        }, [item.type === 'Formation initiale' ? _c('div', {
          staticClass: "grid grid-cols-12 gap-x-4 gap-y-10"
        }, [_c('input-text', {
          staticClass: "md:col-span-6",
          attrs: {
            "error": true,
            "maxlength": 50,
            "necessary": true,
            "value": item.value.intitule_parcours,
            "libelle": "Diplôme et titre obtenu",
            "name": "intitule_parcours"
          },
          on: {
            "input": function (newValue) {
              item.value.intitule_parcours = newValue;
            }
          }
        }), _vm._v(" "), _c('date-picker', {
          staticClass: "col-span-full md:col-span-2",
          attrs: {
            "necessary-date": true,
            "value": item.value.debut_parcours,
            "format": "dd/MM/yyyy",
            "initialview": "year",
            "libelle": "Début",
            "name": "debut_parcours"
          },
          on: {
            "input": function (newValue) {
              if (item.value.fin_parcours === '' || _vm.$verifyDates({
                debut: newValue,
                fin: item.value.fin_parcours
              })) {
                item.value.debut_parcours = newValue;
              } else {
                _vm.badDates();
              }
              _vm.sortParcours();
            }
          }
        }), _vm._v(" "), _c('date-picker', {
          staticClass: "col-span-full md:col-span-2",
          attrs: {
            "necessary-date": true,
            "value": item.value.fin_parcours,
            "format": "dd/MM/yyyy",
            "initialview": "year",
            "libelle": "Fin",
            "name": "fin_parcours"
          },
          on: {
            "input": function (newValue) {
              if (item.value.debut_parcours === '' || _vm.$verifyDates({
                debut: item.value.debut_parcours,
                fin: newValue
              })) {
                item.value.fin_parcours = newValue;
              } else {
                _vm.badDates();
              }
            }
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-2",
          attrs: {
            "necessary": true,
            "value": item.value.localisation_parcours,
            "libelle": "Ville",
            "name": "localisation_parcours"
          },
          on: {
            "input": function (newValue) {
              item.value.localisation_parcours = newValue;
            }
          }
        }), _vm._v(" "), _c('input-select', {
          staticClass: "md:col-span-6",
          attrs: {
            "datas": [{
              value: 'Aucun'
            }, {
              value: 'Niveau 3 - CAP, BEP'
            }, {
              value: 'Niveau 4 - Baccalauréat'
            }, {
              value: 'Niveau 5 - DEUG, BTS, DUT, DEUST'
            }, {
              value: 'Niveau 6 - Licence, licence professionnelle, BUT, Maîtrise, master 1'
            }, {
              value: 'Niveau 7 - Master, diplôme d\'études approfondies, diplôme d\'études supérieures spécialisées, diplôme d\'ingénieur'
            }, {
              value: 'Niveau 8 - Doctorat, habilitation à diriger des recherches'
            }, {
              value: 'Autre'
            }],
            "necessary": true,
            "value": item.value.niveau_cursus,
            "libelle": "Niveau de formation",
            "name": "niveau_cursus"
          },
          on: {
            "input": function (newValue) {
              item.value.niveau_cursus = newValue;
            }
          }
        }), _vm._v(" "), _c('transition', {
          attrs: {
            "enter-active-class": "ease-in duration-300",
            "enter-class": "opacity-0",
            "leave-active-class": "ease-out duration-300",
            "leave-to-class": "opacity-0"
          }
        }, [item.value.niveau_cursus === 'Autres' ? _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "necessary": true,
            "value": item.value.niveau_cursus_precis,
            "libelle": "Autre niveau",
            "name": "niveau_cursus_precis"
          },
          on: {
            "input": function (newValue) {
              item.value.niveau_cursus_precis = newValue;
            }
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('input-select', {
          staticClass: "md:col-span-6",
          attrs: {
            "datas": [{
              value: 'Jamais scolarisé(e)'
            }, {
              value: 'Scolarisé(e) en Etablissement Médico Social (IME-IMPRO, ITEP...)'
            }, {
              value: 'Collège (Classe ordinaire)'
            }, {
              value: 'Collège UPI'
            }, {
              value: 'Lycée (Classe ordinaire)'
            }, {
              value: 'Lycée UPI'
            }, {
              value: 'Enseignement technique ou professionnel court (CAP, BEP etc...)'
            }, {
              value: 'Enseignement technique ou professionnel long (Brevet pro, Bac pro etc...)'
            }, {
              value: 'Universités ou études supérieures'
            }, {
              value: 'Non précisé'
            }],
            "necessary": true,
            "value": item.value.etablissement_cursus,
            "libelle": "Type d'établissement",
            "name": "etablissement_cursus"
          },
          on: {
            "input": function (newValue) {
              item.value.etablissement_cursus = newValue;
            }
          }
        }), _vm._v(" "), _c('h4', {
          staticClass: "col-span-full text-gray-600 my-5 lg:my-10"
        }, [_vm._v("\n              Les compétences acquises pendant votre formation\n            ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-full md:col-span-4"
        }, [_c('div', {
          staticClass: "block"
        }, [_c('label', {
          staticClass: "text-base text-gray-900"
        }, [_vm._v("Pratiques professionnelles")]), _vm._v(" "), _c('em', {
          staticClass: "block text-sm text-gray-600"
        }, [_c('info-bulle', {
          attrs: {
            "is-libelle-input": true,
            "libelle": "Ensemble des moyens (connaissances et informations techniques, habilité pratique...) qui permettent l’accomplissement d’une tâche.",
            "name": "pratiques_formation"
          },
          scopedSlots: _vm._u([{
            key: "libelleBefore",
            fn: function () {
              return [_vm._v("\n                      être capable de...\n                    ")];
            },
            proxy: true
          }], null, true)
        })], 1)]), _vm._v(" "), _vm._l(item.value.pratiques, function (pratique, i) {
          return _c('div', {
            key: i,
            staticClass: "flex content-center lg:pr-10 pt-5"
          }, [_c('delete-button', {
            staticClass: "md:pt-2",
            on: {
              "del": function ($event) {
                return _vm.deleteItem(item.value.pratiques, i);
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "px-4",
            attrs: {
              "necessary": true,
              "value": pratique.value,
              "libelle": "",
              "name": "pratiques"
            },
            on: {
              "input": function (newValue) {
                pratique.value = newValue;
              }
            }
          })], 1);
        }), _vm._v(" "), _c('add-button', {
          staticClass: "mt-5",
          attrs: {
            "libelle": "Ajouter une pratique"
          },
          on: {
            "add": function ($event) {
              return _vm.addItem('competences', item.value.pratiques);
            }
          }
        })], 2), _vm._v(" "), _c('div', {
          staticClass: "col-span-full md:col-span-4"
        }, [_c('div', {
          staticClass: "block"
        }, [_c('label', {
          staticClass: "text-base text-gray-900 font-medium"
        }, [_vm._v("Connaissances associées")]), _vm._v(" "), _c('em', {
          staticClass: "block text-sm text-gray-600"
        }, [_c('info-bulle', {
          attrs: {
            "is-libelle-input": true,
            "libelle": "Ensemble des savoirs théoriques, techniques et pratiques acquis par l’étude (formation initiale ou professionnelle) ou l’expérience.",
            "name": "connaissances_formation"
          },
          scopedSlots: _vm._u([{
            key: "libelleBefore",
            fn: function () {
              return [_vm._v("\n                      Théoriques, procédurales...\n                    ")];
            },
            proxy: true
          }], null, true)
        })], 1)]), _vm._v(" "), _vm._l(item.value.connaissances, function (connaissance, i) {
          return _c('div', {
            key: i,
            staticClass: "flex content-center lg:pr-10 pt-5"
          }, [_c('delete-button', {
            staticClass: "md:pt-2",
            on: {
              "del": function ($event) {
                return _vm.deleteItem(item.value.connaissances, i);
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "px-4",
            attrs: {
              "necessary": true,
              "value": connaissance.value,
              "libelle": "",
              "name": "connaissances"
            },
            on: {
              "input": function (newValue) {
                connaissance.value = newValue;
              }
            }
          })], 1);
        }), _vm._v(" "), _c('add-button', {
          staticClass: "mt-5",
          attrs: {
            "libelle": "Ajouter une connaissance"
          },
          on: {
            "add": function ($event) {
              return _vm.addItem('competences', item.value.connaissances);
            }
          }
        })], 2), _vm._v(" "), _c('div', {
          staticClass: "col-span-full md:col-span-4"
        }, [_c('div', {
          staticClass: "block"
        }, [_c('label', {
          staticClass: "text-base text-gray-900 font-medium"
        }, [_c('info-bulle', {
          attrs: {
            "size-less": true,
            "libelle": "Capacité de produire des actions et des réactions adaptées à l’environnement humain.",
            "name": "comportements_formation"
          },
          scopedSlots: _vm._u([{
            key: "libelleBefore",
            fn: function () {
              return [_vm._v("\n                      Comportements / aptitudes\n                    ")];
            },
            proxy: true
          }], null, true)
        })], 1), _vm._v(" "), _c('em', {
          staticClass: "block text-sm text-gray-600"
        }, [_c('br')])]), _vm._v(" "), _vm._l(item.value.comportements, function (comportement, i) {
          return _c('div', {
            key: i,
            staticClass: "flex content-center lg:pr-10 pt-5"
          }, [_c('delete-button', {
            staticClass: "md:pt-2",
            on: {
              "del": function ($event) {
                return _vm.deleteItem(item.value.comportements, i);
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "px-4",
            attrs: {
              "necessary": true,
              "value": comportement.value,
              "libelle": "",
              "name": "comportements"
            },
            on: {
              "input": function (newValue) {
                comportement.value = newValue;
              }
            }
          })], 1);
        }), _vm._v(" "), _c('add-button', {
          staticClass: "mt-8",
          attrs: {
            "libelle": "Ajouter une aptitude"
          },
          on: {
            "add": function ($event) {
              return _vm.addItem('competences', item.value.comportements);
            }
          }
        })], 2), _vm._v(" "), _c('delete-button', {
          staticClass: "col-span-full",
          attrs: {
            "libelle": "Supprimer ce parcours"
          },
          on: {
            "del": function ($event) {
              return _vm.deleteItem(_vm.form.parcours, num);
            }
          }
        })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.parcoursDisplayed === num,
            expression: "parcoursDisplayed === num"
          }],
          key: 'parcours_professionnel' + num
        }, [item.type === 'Parcours professionnel' ? _c('div', {
          staticClass: "bg-white grid grid-cols-12 gap-x-4 gap-y-10"
        }, [_c('date-picker', {
          staticClass: "col-span-full md:col-span-3",
          attrs: {
            "necessary-date": true,
            "value": item.value.debut_parcours,
            "format": "dd/MM/yyyy",
            "initialview": "year",
            "libelle": "Début",
            "name": "debut_parcours"
          },
          on: {
            "input": function (newValue) {
              if (item.value.fin_parcours === '' || _vm.$verifyDates({
                debut: newValue,
                fin: item.value.fin_parcours
              })) {
                item.value.debut_parcours = newValue;
              } else {
                _vm.badDates();
              }
              _vm.sortParcours();
            }
          }
        }), _vm._v(" "), _c('date-picker', {
          staticClass: "col-span-full md:col-span-3",
          attrs: {
            "necessary-date": true,
            "value": item.value.fin_parcours,
            "format": "dd/MM/yyyy",
            "initialview": "year",
            "libelle": "Fin",
            "name": "fin_parcours"
          },
          on: {
            "input": function (newValue) {
              if (item.value.debut_parcours === '' || _vm.$verifyDates({
                debut: item.value.debut_parcours,
                fin: newValue
              })) {
                item.value.fin_parcours = newValue;
              } else {
                _vm.badDates();
              }
            }
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "col-start-1 md:col-span-3",
          attrs: {
            "necessary": true,
            "value": item.value.structure_accueil_parcours,
            "libelle": "Nom de la structure d'accueil",
            "name": "structure_accueil_parcours"
          },
          on: {
            "input": function (newValue) {
              item.value.structure_accueil_parcours = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "necessary": true,
            "value": item.value.localisation_parcours,
            "libelle": "Localisation",
            "name": "localisation_parcours"
          },
          on: {
            "input": function (newValue) {
              item.value.localisation_parcours = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "col-start-1 md:col-span-3",
          attrs: {
            "error": true,
            "maxlength": 50,
            "necessary": true,
            "value": item.value.intitule_parcours,
            "libelle": "Poste occupé",
            "name": "intitule_parcours"
          },
          on: {
            "input": function (newValue) {
              item.value.intitule_parcours = newValue;
            }
          }
        }), _vm._v(" "), _c('input-select', {
          staticClass: "md:col-span-3",
          attrs: {
            "datas": [{
              value: 'Contrat de soutien et d\'aide par le travail'
            }, {
              value: 'Contrat de travail à durée indéterminée'
            }, {
              value: 'Contrat de travail à durée déterminée'
            }, {
              value: 'Contrat d\'apprentissage'
            }, {
              value: 'Contrat de prestation de service'
            }, {
              value: 'Contrat de professionnalisation'
            }, {
              value: 'Contrat de travail intérimaire'
            }, {
              value: 'Contrat unique d\'insertion - Secteur privé'
            }, {
              value: 'Contrat unique d\'insertion - Secteur public'
            }, {
              value: 'Contrat saisonnier'
            }, {
              value: 'Contrat de mise à disposition'
            }, {
              value: 'Autres contrats'
            }],
            "necessary": true,
            "value": item.value.type_contrat_pro,
            "libelle": "Type de contrat",
            "name": "type_contrat_pro"
          },
          on: {
            "input": function (newValue) {
              item.value.type_contrat_pro = newValue;
            }
          }
        }), _vm._v(" "), _c('transition', {
          attrs: {
            "enter-active-class": "ease-in duration-300",
            "enter-class": "opacity-0",
            "leave-active-class": "ease-out duration-300",
            "leave-to-class": "opacity-0"
          }
        }, [item.value.type_contrat_pro === 'Autres contrats' ? _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "necessary": true,
            "value": item.value.type_contrat_pro_precis,
            "libelle": "Autre type de contrat",
            "name": "type_contrat_pro_precis"
          },
          on: {
            "input": function (newValue) {
              item.value.type_contrat_pro_precis = newValue;
            }
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('input-select', {
          staticClass: "md:col-span-3",
          attrs: {
            "datas": [{
              value: 'Temps plein'
            }, {
              value: 'Temps partiel'
            }],
            "necessary": true,
            "value": item.value.temps_pro,
            "libelle": "Temps plein/partiel",
            "name": "temps_pro"
          },
          on: {
            "input": function (newValue) {
              item.value.temps_pro = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "necessary": true,
            "value": item.value.temps_travail_pro,
            "libelle": "Temps de travail hebdo (en h)",
            "name": "temps_travail_pro"
          },
          on: {
            "input": function (newValue) {
              item.value.temps_travail_pro = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text-area', {
          staticClass: "lg:col-start-1 md:col-span-6",
          attrs: {
            "necessary": true,
            "value": item.value.aborde_parcours,
            "libelle": "Les activités et tâches principales qui vous ont été confiées",
            "name": "aborde_parcours"
          },
          on: {
            "input": function (newValue) {
              item.value.aborde_parcours = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text-area', {
          staticClass: "md:col-span-6",
          attrs: {
            "value": item.value.commentaires_parcours,
            "libelle": "Commentaires",
            "name": "commentaires_parcours"
          },
          on: {
            "input": function (newValue) {
              item.value.commentaires_parcours = newValue;
            }
          }
        }), _vm._v(" "), _c('h4', {
          staticClass: "col-span-full text-gray-600 my-10"
        }, [_vm._v("\n              Les compétences mobilisées pour mener à bien vos activités ou tâches professionnelles\n            ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-full md:col-span-4"
        }, [_c('div', {
          staticClass: "block"
        }, [_c('label', {
          staticClass: "text-base text-gray-900 font-medium"
        }, [_vm._v("Pratiques\n                  professionnelles")]), _vm._v(" "), _c('em', {
          staticClass: "block text-sm text-gray-600"
        }, [_c('info-bulle', {
          attrs: {
            "is-libelle-input": true,
            "libelle": "Ensemble des moyens (connaissances et informations techniques, habilité pratique...) qui permettent l’accomplissement d’une tâche.",
            "name": "pratiques_pro"
          },
          scopedSlots: _vm._u([{
            key: "libelleBefore",
            fn: function () {
              return [_vm._v("\n                      être capable de...\n                    ")];
            },
            proxy: true
          }], null, true)
        })], 1)]), _vm._v(" "), _vm._l(item.value.pratiques, function (pratique, i) {
          return _c('div', {
            key: i,
            staticClass: "flex content-center lg:pr-10 pt-5"
          }, [_c('delete-button', {
            staticClass: "md:pt-2",
            on: {
              "del": function ($event) {
                return _vm.deleteItem(item.value.pratiques, i);
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "px-4",
            attrs: {
              "necessary": true,
              "value": pratique.value,
              "libelle": "",
              "name": "pratiques"
            },
            on: {
              "input": function (newValue) {
                pratique.value = newValue;
              }
            }
          })], 1);
        }), _vm._v(" "), _c('add-button', {
          staticClass: "mt-5",
          attrs: {
            "libelle": "Ajouter une pratique"
          },
          on: {
            "add": function ($event) {
              return _vm.addItem('competences', item.value.pratiques);
            }
          }
        })], 2), _vm._v(" "), _c('div', {
          staticClass: "col-span-full md:col-span-4"
        }, [_c('div', {
          staticClass: "block"
        }, [_c('label', {
          staticClass: "text-base text-gray-900 font-medium"
        }, [_vm._v("Connaissances associées")]), _vm._v(" "), _c('em', {
          staticClass: "block text-sm text-gray-600"
        }, [_c('info-bulle', {
          attrs: {
            "is-libelle-input": true,
            "libelle": "Ensemble des savoirs théoriques, techniques et pratiques acquis par l’étude (formation initiale ou professionnelle) ou l’expérience.",
            "name": "connaissances_pro"
          },
          scopedSlots: _vm._u([{
            key: "libelleBefore",
            fn: function () {
              return [_vm._v("\n                      Théoriques, procédurales...\n                    ")];
            },
            proxy: true
          }], null, true)
        })], 1)]), _vm._v(" "), _vm._l(item.value.connaissances, function (connaissance, i) {
          return _c('div', {
            key: i,
            staticClass: "flex content-center lg:pr-10 pt-5"
          }, [_c('delete-button', {
            staticClass: "md:pt-2",
            on: {
              "del": function ($event) {
                return _vm.deleteItem(item.value.connaissances, i);
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "px-4",
            attrs: {
              "necessary": true,
              "value": connaissance.value,
              "libelle": "",
              "name": "connaissances"
            },
            on: {
              "input": function (newValue) {
                connaissance.value = newValue;
              }
            }
          })], 1);
        }), _vm._v(" "), _c('add-button', {
          staticClass: "mt-5",
          attrs: {
            "libelle": "Ajouter une connaissance"
          },
          on: {
            "add": function ($event) {
              return _vm.addItem('competences', item.value.connaissances);
            }
          }
        })], 2), _vm._v(" "), _c('div', {
          staticClass: "col-span-full md:col-span-4"
        }, [_c('div', {
          staticClass: "block"
        }, [_c('label', {
          staticClass: "text-base text-gray-900 font-medium"
        }, [_c('info-bulle', {
          attrs: {
            "size-less": true,
            "libelle": "Capacité de produire des actions et des réactions adaptées à l’environnement humain.",
            "name": "comportements_pro"
          },
          scopedSlots: _vm._u([{
            key: "libelleBefore",
            fn: function () {
              return [_vm._v("\n                      Comportements / aptitudes\n                    ")];
            },
            proxy: true
          }], null, true)
        })], 1), _vm._v(" "), _c('em', {
          staticClass: "block text-sm text-gray-600"
        }, [_c('br')])]), _vm._v(" "), _vm._l(item.value.comportements, function (comportement, i) {
          return _c('div', {
            key: i,
            staticClass: "flex content-center lg:pr-10 pt-5"
          }, [_c('delete-button', {
            staticClass: "md:pt-2",
            on: {
              "del": function ($event) {
                return _vm.deleteItem(item.value.comportements, i);
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "px-4",
            attrs: {
              "necessary": true,
              "value": comportement.value,
              "libelle": "",
              "name": "comportements"
            },
            on: {
              "input": function (newValue) {
                comportement.value = newValue;
              }
            }
          })], 1);
        }), _vm._v(" "), _c('add-button', {
          staticClass: "mt-5",
          attrs: {
            "libelle": "Ajouter une aptitude"
          },
          on: {
            "add": function ($event) {
              return _vm.addItem('competences', item.value.comportements);
            }
          }
        })], 2), _vm._v(" "), _c('delete-button', {
          staticClass: "col-span-full",
          attrs: {
            "libelle": "Supprimer ce parcours"
          },
          on: {
            "del": function ($event) {
              return _vm.deleteItem(_vm.form.parcours, num);
            }
          }
        })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.parcoursDisplayed === num,
            expression: "parcoursDisplayed === num"
          }],
          key: 'formation_professionnelle_continue' + num
        }, [item.type === 'Formation professionnelle continue' ? _c('div', {
          staticClass: "bg-white grid grid-cols-12 gap-x-4 gap-y-10"
        }, [_c('date-picker', {
          staticClass: "col-span-full md:col-span-3",
          attrs: {
            "necessary-date": true,
            "value": item.value.debut_parcours,
            "format": "dd/MM/yyyy",
            "initialview": "year",
            "libelle": "Début",
            "name": "debut_parcours"
          },
          on: {
            "input": function (newValue) {
              if (item.value.fin_parcours === '' || _vm.$verifyDates({
                debut: newValue,
                fin: item.value.fin_parcours
              })) {
                item.value.debut_parcours = newValue;
              } else {
                _vm.badDates();
              }
              _vm.sortParcours();
            }
          }
        }), _vm._v(" "), _c('date-picker', {
          staticClass: "col-span-full md:col-span-3",
          attrs: {
            "necessary-date": true,
            "value": item.value.fin_parcours,
            "format": "dd/MM/yyyy",
            "initialview": "year",
            "libelle": "Fin",
            "name": "fin_parcours"
          },
          on: {
            "input": function (newValue) {
              if (item.value.debut_parcours === '' || _vm.$verifyDates({
                debut: item.value.debut_parcours,
                fin: newValue
              })) {
                item.value.fin_parcours = newValue;
              } else {
                _vm.badDates();
              }
            }
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "necessary": true,
            "value": item.value.duree_formation,
            "libelle": "Durée (en h)",
            "name": "duree_formation"
          },
          on: {
            "input": function (newValue) {
              item.value.duree_formation = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "col-start-1 md:col-span-6",
          attrs: {
            "error": true,
            "maxlength": 50,
            "necessary": true,
            "value": item.value.intitule_parcours,
            "libelle": "Intitulé de la formation",
            "name": "intitule_parcours"
          },
          on: {
            "input": function (newValue) {
              item.value.intitule_parcours = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "necessary": true,
            "value": item.value.organisme_formation_pro,
            "libelle": "Organisme de formation",
            "name": "organisme_formation_pro"
          },
          on: {
            "input": function (newValue) {
              item.value.organisme_formation_pro = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "necessary": true,
            "value": item.value.localisation_parcours,
            "libelle": "Localisation",
            "name": "localisation_parcours"
          },
          on: {
            "input": function (newValue) {
              item.value.localisation_parcours = newValue;
            }
          }
        }), _vm._v(" "), _c('input-select', {
          staticClass: "md:col-span-3",
          attrs: {
            "datas": [{
              value: 'Interne'
            }, {
              value: 'Externe'
            }],
            "necessary": true,
            "value": item.value.type_formation_pro,
            "libelle": "Type de formation",
            "name": "type_formation_pro"
          },
          on: {
            "input": function (newValue) {
              item.value.type_formation_pro = newValue;
            }
          }
        }), _vm._v(" "), _c('input-select', {
          staticClass: "md:col-span-3",
          attrs: {
            "datas": [{
              value: 'Oui'
            }, {
              value: 'Non'
            }],
            "necessary": true,
            "value": item.value.attestation_formation_pro,
            "libelle": "Attestation de formation",
            "name": "attestation_formation_pro"
          },
          on: {
            "input": function (newValue) {
              item.value.attestation_formation_pro = newValue;
            }
          }
        }), _vm._v(" "), _c('input-select', {
          staticClass: "md:col-span-3",
          attrs: {
            "datas": [{
              value: 'Aucune'
            }, {
              value: 'Niveau 3 - CAP, BEP'
            }, {
              value: 'Niveau 4 - Baccalauréat'
            }, {
              value: 'Niveau 5 - DEUG, BTS, DUT, DEUST'
            }, {
              value: 'Niveau 6 - Licence, licence professionnelle, BUT, Maîtrise, master 1'
            }, {
              value: 'Niveau 7 - Master, diplôme d\'études approfondies, diplôme d\'études supérieures spécialisées, diplôme d\'ingénieur'
            }, {
              value: 'Niveau 8 - Doctorat, habilitation à diriger des recherches'
            }, {
              value: 'CQP (CQPI)'
            }, {
              value: 'CQPM'
            }, {
              value: 'Reconnaissance CCN'
            }, {
              value: 'Reconnaissance CPNAA/CPNE'
            }, {
              value: 'Certification Professionnelle'
            }, {
              value: 'Diplômes Européens'
            }, {
              value: 'CCP'
            }, {
              value: 'CCF'
            }, {
              value: 'RSFP'
            }, {
              value: 'Attestation de compétences'
            }, {
              value: 'Attestation de Formation'
            }, {
              value: 'Autres'
            }],
            "necessary": true,
            "value": item.value.certifications_obtenues_formation_pro,
            "libelle": "Certifications obtenues",
            "name": "certifications_obtenues_formation_pro"
          },
          on: {
            "input": function (newValue) {
              item.value.certifications_obtenues_formation_pro = newValue;
            }
          }
        }), _vm._v(" "), _c('transition', {
          attrs: {
            "enter-active-class": "ease-in duration-300",
            "enter-class": "opacity-0",
            "leave-active-class": "ease-out duration-300",
            "leave-to-class": "opacity-0"
          }
        }, [item.value.certifications_obtenues_formation_pro === 'Autres' ? _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "necessary": true,
            "value": item.value.autres_certifications_formation_pro,
            "libelle": "Autres certifications",
            "name": "autres_certifications_formation_pro"
          },
          on: {
            "input": function (newValue) {
              item.value.autres_certifications_formation_pro = newValue;
            }
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('input-select', {
          staticClass: "md:col-span-3",
          attrs: {
            "datas": [{
              value: 'Formation de Professionnalisation'
            }, {
              value: 'Formation d\'Intégration'
            }, {
              value: 'Formation de perfectionnement'
            }, {
              value: 'Formation de préparation aux concours et examens professionnels'
            }, {
              value: 'Formation personnelle'
            }, {
              value: 'Autre'
            }],
            "necessary": true,
            "value": item.value.raisons_formation_pro,
            "libelle": "Formation suivie au titre de",
            "name": "raisons_formation_pro",
            "left": true
          },
          on: {
            "input": function (newValue) {
              item.value.raisons_formation_pro = newValue;
            }
          }
        }), _vm._v(" "), _c('transition', {
          attrs: {
            "enter-active-class": "ease-in duration-300",
            "enter-class": "opacity-0",
            "leave-active-class": "ease-out duration-300",
            "leave-to-class": "opacity-0"
          }
        }, [item.value.raisons_formation_pro === 'Autre' ? _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "necessary": true,
            "value": item.value.raisons_formation_pro_precis,
            "libelle": "Autre raisons",
            "name": "raisons_formation_pro_precis"
          },
          on: {
            "input": function (newValue) {
              item.value.raisons_formation_pro_precis = newValue;
            }
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('input-select', {
          staticClass: "md:col-span-3",
          attrs: {
            "datas": [{
              value: 'En cours'
            }, {
              value: 'Menée à son terme'
            }, {
              value: 'Interrompue'
            }],
            "necessary": true,
            "value": item.value.precision_formation_pro,
            "libelle": "Précision",
            "name": "precision_formation_pro"
          },
          on: {
            "input": function (newValue) {
              item.value.precision_formation_pro = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text-area', {
          staticClass: "lg:col-start-1 md:col-span-6",
          attrs: {
            "necessary": true,
            "value": item.value.aborde_formation,
            "libelle": "Ce que j'ai appris (connaissances acquises ou abordées)",
            "name": "aborde_formation"
          },
          on: {
            "input": function (newValue) {
              item.value.aborde_formation = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text-area', {
          staticClass: "md:col-span-6",
          attrs: {
            "value": item.value.commentaires_parcours,
            "libelle": "Commentaires",
            "name": "commentaires_parcours"
          },
          on: {
            "input": function (newValue) {
              item.value.commentaires_parcours = newValue;
            }
          }
        }), _vm._v(" "), _c('h4', {
          staticClass: "col-span-full text-gray-600 my-10"
        }, [_vm._v("\n              Les compétences acquises pendant votre formation\n            ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-full md:col-span-4"
        }, [_c('div', {
          staticClass: "block"
        }, [_c('label', {
          staticClass: "text-base text-gray-900 font-medium"
        }, [_vm._v("Pratiques\n                  professionnelles")]), _vm._v(" "), _c('em', {
          staticClass: "block text-sm text-gray-600"
        }, [_c('info-bulle', {
          attrs: {
            "is-libelle-input": true,
            "libelle": "Ensemble des moyens (connaissances et informations techniques, habilité pratique...) qui permettent l’accomplissement d’une tâche.",
            "name": "pratiques_formation_pro"
          },
          scopedSlots: _vm._u([{
            key: "libelleBefore",
            fn: function () {
              return [_vm._v("\n                      être capable de...\n                    ")];
            },
            proxy: true
          }], null, true)
        })], 1)]), _vm._v(" "), _vm._l(item.value.pratiques, function (pratique, i) {
          return _c('div', {
            key: i,
            staticClass: "flex content-center lg:pr-10 pt-5"
          }, [_c('delete-button', {
            staticClass: "md:pt-2",
            on: {
              "del": function ($event) {
                return _vm.deleteItem(item.value.pratiques, i);
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "px-4",
            attrs: {
              "necessary": true,
              "value": pratique.value,
              "libelle": "",
              "name": "pratiques"
            },
            on: {
              "input": function (newValue) {
                pratique.value = newValue;
              }
            }
          })], 1);
        }), _vm._v(" "), _c('add-button', {
          staticClass: "mt-5",
          attrs: {
            "libelle": "Ajouter une pratique"
          },
          on: {
            "add": function ($event) {
              return _vm.addItem('competences', item.value.pratiques);
            }
          }
        })], 2), _vm._v(" "), _c('div', {
          staticClass: "col-span-full md:col-span-4"
        }, [_c('div', {
          staticClass: "block"
        }, [_c('label', {
          staticClass: "text-base text-gray-900 font-medium"
        }, [_vm._v("Connaissances associées")]), _vm._v(" "), _c('em', {
          staticClass: "block text-sm text-gray-600"
        }, [_c('info-bulle', {
          attrs: {
            "is-libelle-input": true,
            "libelle": "Ensemble des savoirs théoriques, techniques et pratiques acquis par l’étude (formation initiale ou professionnelle) ou l’expérience.",
            "name": "connaissances_formation_pro"
          },
          scopedSlots: _vm._u([{
            key: "libelleBefore",
            fn: function () {
              return [_vm._v("\n                      Théoriques, procédurales...\n                    ")];
            },
            proxy: true
          }], null, true)
        })], 1)]), _vm._v(" "), _vm._l(item.value.connaissances, function (connaissance, i) {
          return _c('div', {
            key: i,
            staticClass: "flex content-center lg:pr-10 pt-5"
          }, [_c('delete-button', {
            staticClass: "md:pt-2",
            on: {
              "del": function ($event) {
                return _vm.deleteItem(item.value.connaissances, i);
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "px-4",
            attrs: {
              "necessary": true,
              "value": connaissance.value,
              "libelle": "",
              "name": "connaissances"
            },
            on: {
              "input": function (newValue) {
                connaissance.value = newValue;
              }
            }
          })], 1);
        }), _vm._v(" "), _c('add-button', {
          staticClass: "mt-5",
          attrs: {
            "libelle": "Ajouter une connaissance"
          },
          on: {
            "add": function ($event) {
              return _vm.addItem('competences', item.value.connaissances);
            }
          }
        })], 2), _vm._v(" "), _c('div', {
          staticClass: "col-span-full md:col-span-4"
        }, [_c('div', {
          staticClass: "block"
        }, [_c('label', {
          staticClass: "text-base text-gray-900 font-medium"
        }, [_c('info-bulle', {
          attrs: {
            "size-less": true,
            "libelle": "Capacité de produire des actions et des réactions adaptées à l’environnement humain.",
            "name": "comportements_formation_pro"
          },
          scopedSlots: _vm._u([{
            key: "libelleBefore",
            fn: function () {
              return [_vm._v("\n                      Comportements / aptitudes\n                    ")];
            },
            proxy: true
          }], null, true)
        })], 1), _vm._v(" "), _c('em', {
          staticClass: "block text-sm text-gray-600"
        }, [_c('br')])]), _vm._v(" "), _vm._l(item.value.comportements, function (comportement, i) {
          return _c('div', {
            key: i,
            staticClass: "flex content-center lg:pr-10 pt-5"
          }, [_c('delete-button', {
            staticClass: "md:pt-2",
            on: {
              "del": function ($event) {
                return _vm.deleteItem(item.value.comportements, i);
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "px-4",
            attrs: {
              "necessary": true,
              "value": comportement.value,
              "libelle": "",
              "name": "comportements"
            },
            on: {
              "input": function (newValue) {
                comportement.value = newValue;
              }
            }
          })], 1);
        }), _vm._v(" "), _c('add-button', {
          staticClass: "mt-5",
          attrs: {
            "libelle": "Ajouter une aptitude"
          },
          on: {
            "add": function ($event) {
              return _vm.addItem('competences', item.value.comportements);
            }
          }
        })], 2), _vm._v(" "), _c('delete-button', {
          staticClass: "col-span-full",
          attrs: {
            "libelle": "Supprimer ce parcours"
          },
          on: {
            "del": function ($event) {
              return _vm.deleteItem(_vm.form.parcours, num);
            }
          }
        })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.parcoursDisplayed === num,
            expression: "parcoursDisplayed === num"
          }],
          key: 'stage' + num
        }, [item.type === 'Stage' && !item.projet ? _c('div', {
          staticClass: "bg-white grid grid-cols-12 gap-x-4 gap-y-10"
        }, [_c('date-picker', {
          staticClass: "col-span-full md:col-span-3",
          attrs: {
            "necessary-date": true,
            "value": item.value.debut_parcours,
            "format": "dd/MM/yyyy",
            "initialview": "year",
            "libelle": "Début",
            "name": "debut_parcours"
          },
          on: {
            "input": function (newValue) {
              if (_vm.$verifyDates({
                debut: newValue,
                fin: item.value.fin_parcours
              })) {
                item.value.debut_parcours = newValue;
              } else {
                _vm.badDates();
              }
              _vm.sortParcours();
            }
          }
        }), _vm._v(" "), _c('date-picker', {
          staticClass: "col-span-full md:col-span-3",
          attrs: {
            "necessary-date": true,
            "value": item.value.fin_parcours,
            "format": "dd/MM/yyyy",
            "initialview": "year",
            "libelle": "Fin",
            "name": "fin_parcours"
          },
          on: {
            "input": function (newValue) {
              if (_vm.$verifyDates({
                debut: item.value.debut_parcours,
                fin: newValue
              })) {
                item.value.fin_parcours = newValue;
              } else {
                _vm.badDates();
              }
            }
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "necessary": true,
            "value": item.value.duree_stage,
            "libelle": "Durée du stage (en h)",
            "name": "duree_stage"
          },
          on: {
            "input": function (newValue) {
              item.value.duree_stage = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-6 col-start-1",
          attrs: {
            "error": true,
            "maxlength": 50,
            "necessary": true,
            "value": item.value.intitule_parcours,
            "libelle": "Intitulé du stage",
            "name": "intitule_parcours"
          },
          on: {
            "input": function (newValue) {
              item.value.intitule_parcours = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "necessary": true,
            "value": item.value.structure_accueil_parcours,
            "libelle": "Nom de la structure d'accueil",
            "name": "structure_accueil_parcours"
          },
          on: {
            "input": function (newValue) {
              item.value.structure_accueil_parcours = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "necessary": true,
            "value": item.value.localisation_parcours,
            "libelle": "Localisation",
            "name": "localisation_parcours"
          },
          on: {
            "input": function (newValue) {
              item.value.localisation_parcours = newValue;
            }
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "col-span-full grid grid-cols-5 gap-x-4 gap-y-10"
        }, [_c('input-select', {
          staticClass: "md:col-span-1",
          attrs: {
            "datas": [{
              value: 'Interne'
            }, {
              value: 'Externe'
            }],
            "necessary": true,
            "value": item.value.type_stage,
            "label-libelle": "<div><b>Interne</b> : Période d’apprentissage, de formation ou de perfectionnement dans une entreprise, un service ou une association en vue d'exercer une activité professionnelle ou autre. <div><b>Externe</b> : Période d’apprentissage, de formation ou de perfectionnement effectuée hors de son entreprise, son association ou son établissement d’origine.",
            "libelle": "Type de stage",
            "name": "type_stage"
          },
          on: {
            "input": function (newValue) {
              item.value.type_stage = newValue;
            }
          }
        }), _vm._v(" "), _c('input-select', {
          staticClass: "md:col-span-1",
          attrs: {
            "datas": [{
              value: 'Ordinaire'
            }, {
              value: 'Protégé'
            }],
            "necessary": true,
            "value": item.value.milieu_stage,
            "label-libelle": "<div><b>Ordinaire</b> : Stage effectué dans une entreprise autre qu'un établissement spécialisé. Le milieu ordinaire de travail regroupe les employeurs publics et privés du marché du travail « classique ». <div><b>Protégé</b> : Stage effectué dans un environnement à caractère professionnel où le travail de la personne en situation de handicap est pleinement pris en compte aussi bien sur le plan professionnel que socio-médical et éducatif, et ce en vue de favoriser son épanouissement personnel et social.",
            "libelle": "Stage en milieu",
            "name": "milieu_stage"
          },
          on: {
            "input": function (newValue) {
              item.value.milieu_stage = newValue;
            }
          }
        }), _vm._v(" "), _c('input-select', {
          staticClass: "md:col-span-1",
          attrs: {
            "datas": [{
              value: 'Observation'
            }, {
              value: 'Application'
            }],
            "necessary": true,
            "value": item.value.caracteristiques_stage,
            "label-libelle": "<div><b>Observation</b> : Il permet à un débutant de s’ouvrir au monde professionnel en découvrant un type d’organisation (entreprise, association, administration...), son mode de fonctionnement et son activité, ainsi que les rapports professionnels entre les personnes et un métier et/ou une fonction. <div><b>Application</b> : Il vise à mettre en pratique ses connaissances et à développer des compétences en milieu professionnel avec plus ou moins de responsabilités et d’autonomie selon le niveau du diplôme préparé.",
            "libelle": "Caractéristiques du stage",
            "name": "caracteristiques_stage"
          },
          on: {
            "input": function (newValue) {
              item.value.caracteristiques_stage = newValue;
            }
          }
        }), _vm._v(" "), _c('input-select', {
          staticClass: "md:col-span-1",
          attrs: {
            "datas": [{
              value: 'Oui'
            }, {
              value: 'Non'
            }],
            "necessary": true,
            "value": item.value.attestation_stage,
            "libelle": "Attestation de stage",
            "name": "attestation_stage"
          },
          on: {
            "input": function (newValue) {
              item.value.attestation_stage = newValue;
            }
          }
        }), _vm._v(" "), _c('input-select', {
          staticClass: "md:col-span-1",
          attrs: {
            "datas": [{
              value: 'En cours'
            }, {
              value: 'Mené à son terme'
            }, {
              value: 'Interrompu'
            }],
            "necessary": true,
            "value": item.value.precision_stage,
            "libelle": "Précision",
            "name": "precision_stage"
          },
          on: {
            "input": function (newValue) {
              item.value.precision_stage = newValue;
            }
          }
        }), _vm._v(" "), _c('input-select', {
          staticClass: "md:col-span-1",
          attrs: {
            "datas": [{
              value: 'Oui'
            }, {
              value: 'Non'
            }],
            "necessary": true,
            "value": item.value.tuteur_stage,
            "libelle": "Tuteur de stage",
            "name": "tuteur_stage"
          },
          on: {
            "input": function (newValue) {
              item.value.tuteur_stage = newValue;
            }
          }
        }), _vm._v(" "), item.value.tuteur_stage === 'Oui' ? _c('input-text', {
          staticClass: "md:col-span-1",
          attrs: {
            "necessary": true,
            "value": item.value.nom_tuteur_stage,
            "libelle": "Nom / Prénom",
            "name": "nom_tuteur_stage"
          },
          on: {
            "input": function (newValue) {
              item.value.nom_tuteur_stage = newValue;
            }
          }
        }) : _vm._e(), _vm._v(" "), item.value.tuteur_stage === 'Oui' ? _c('input-text', {
          staticClass: "md:col-span-1",
          attrs: {
            "necessary": true,
            "value": item.value.fonction_tuteur_stage,
            "libelle": "Fonction",
            "name": "fonction_tuteur_stage"
          },
          on: {
            "input": function (newValue) {
              item.value.fonction_tuteur_stage = newValue;
            }
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('input-text-area', {
          staticClass: "lg:col-start-1 md:col-span-6",
          attrs: {
            "necessary": true,
            "value": item.value.aborde_parcours,
            "libelle": "Les activités et tâches principales qui vous ont été confiées",
            "name": "aborde_parcours"
          },
          on: {
            "input": function (newValue) {
              item.value.aborde_parcours = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text-area', {
          staticClass: "md:col-span-6",
          attrs: {
            "value": item.value.commentaires_parcours,
            "libelle": "Commentaires",
            "name": "commentaires_parcours"
          },
          on: {
            "input": function (newValue) {
              item.value.commentaires_parcours = newValue;
            }
          }
        }), _vm._v(" "), _c('h4', {
          staticClass: "col-span-full text-gray-600 my-10"
        }, [_vm._v("\n              Les compétences mobilisées pour mener à bien vos activités ou tâches professionnelles\n            ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-full xxl:col-span-4"
        }, [_c('div', {
          staticClass: "block"
        }, [_c('label', {
          staticClass: "text-base text-gray-900 font-medium"
        }, [_vm._v("Pratiques\n                  professionnelles")]), _vm._v(" "), _c('em', {
          staticClass: "block text-sm text-gray-600"
        }, [_c('info-bulle', {
          attrs: {
            "is-libelle-input": true,
            "libelle": "Ensemble des moyens (connaissances et informations techniques, habilité pratique...) qui permettent l’accomplissement d’une tâche.",
            "name": "pratiques_stage"
          },
          scopedSlots: _vm._u([{
            key: "libelleBefore",
            fn: function () {
              return [_vm._v("\n                      être capable de...\n                    ")];
            },
            proxy: true
          }], null, true)
        })], 1)]), _vm._v(" "), _vm._l(item.value.pratiques, function (pratique, i) {
          return _c('div', {
            key: i,
            staticClass: "flex content-center lg:pr-10 pt-5"
          }, [_c('delete-button', {
            staticClass: "md:pt-2",
            on: {
              "del": function ($event) {
                return _vm.deleteItem(item.value.pratiques, i);
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "px-4",
            attrs: {
              "necessary": true,
              "value": pratique.value,
              "libelle": "",
              "name": "pratiques"
            },
            on: {
              "input": function (newValue) {
                pratique.value = newValue;
              }
            }
          })], 1);
        }), _vm._v(" "), _c('add-button', {
          staticClass: "mt-5",
          attrs: {
            "libelle": "Ajouter une pratique"
          },
          on: {
            "add": function ($event) {
              return _vm.addItem('competences', item.value.pratiques);
            }
          }
        })], 2), _vm._v(" "), _c('div', {
          staticClass: "col-span-full xxl:col-span-4"
        }, [_c('div', {
          staticClass: "block"
        }, [_c('label', {
          staticClass: "text-sm text-gray-900 font-medium"
        }, [_vm._v("Connaissances associées")]), _vm._v(" "), _c('em', {
          staticClass: "block text-base text-gray-600"
        }, [_c('info-bulle', {
          attrs: {
            "is-libelle-input": true,
            "libelle": "Ensemble des savoirs théoriques, techniques et pratiques acquis par l’étude (formation initiale ou professionnelle) ou l’expérience.",
            "name": "connaissances_stage"
          },
          scopedSlots: _vm._u([{
            key: "libelleBefore",
            fn: function () {
              return [_vm._v("\n                      Théoriques, procédurales...\n                    ")];
            },
            proxy: true
          }], null, true)
        })], 1)]), _vm._v(" "), _vm._l(item.value.connaissances, function (connaissance, i) {
          return _c('div', {
            key: i,
            staticClass: "flex content-center lg:pr-10 pt-5"
          }, [_c('delete-button', {
            staticClass: "md:pt-2",
            on: {
              "del": function ($event) {
                return _vm.deleteItem(item.value.connaissances, i);
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "px-4",
            attrs: {
              "necessary": true,
              "value": connaissance.value,
              "libelle": "",
              "name": "connaissances"
            },
            on: {
              "input": function (newValue) {
                connaissance.value = newValue;
              }
            }
          })], 1);
        }), _vm._v(" "), _c('add-button', {
          staticClass: "mt-5",
          attrs: {
            "libelle": "Ajouter une connaissance"
          },
          on: {
            "add": function ($event) {
              return _vm.addItem('competences', item.value.connaissances);
            }
          }
        })], 2), _vm._v(" "), _c('div', {
          staticClass: "col-span-full xxl:col-span-4"
        }, [_c('div', {
          staticClass: "block"
        }, [_c('label', {
          staticClass: "text-base text-gray-900 font-medium"
        }, [_c('info-bulle', {
          attrs: {
            "size-less": true,
            "libelle": "Capacité de produire des actions et des réactions adaptées à l’environnement humain.",
            "name": "comportements_stage"
          },
          scopedSlots: _vm._u([{
            key: "libelleBefore",
            fn: function () {
              return [_vm._v("\n                      Comportements / aptitudes\n                    ")];
            },
            proxy: true
          }], null, true)
        })], 1), _vm._v(" "), _c('em', {
          staticClass: "hidden lg:block text-sm text-gray-600"
        }, [_c('br')])]), _vm._v(" "), _vm._l(item.value.comportements, function (comportement, i) {
          return _c('div', {
            key: i,
            staticClass: "flex content-center pr-10 pt-5"
          }, [_c('delete-button', {
            staticClass: "md:pt-2",
            on: {
              "del": function ($event) {
                return _vm.deleteItem(item.value.comportements, i);
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "px-4",
            attrs: {
              "necessary": true,
              "value": comportement.value,
              "libelle": "",
              "name": "comportements"
            },
            on: {
              "input": function (newValue) {
                comportement.value = newValue;
              }
            }
          })], 1);
        }), _vm._v(" "), _c('add-button', {
          staticClass: "mt-5",
          attrs: {
            "libelle": "Ajouter une aptitude"
          },
          on: {
            "add": function ($event) {
              return _vm.addItem('competences', item.value.comportements);
            }
          }
        })], 2), _vm._v(" "), _c('delete-button', {
          staticClass: "col-span-full",
          attrs: {
            "libelle": "Supprimer ce parcours"
          },
          on: {
            "del": function ($event) {
              return _vm.deleteItem(_vm.form.parcours, num);
            }
          }
        })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.parcoursDisplayed === num,
            expression: "parcoursDisplayed === num"
          }],
          key: 'autre_exp' + num
        }, [item.type === 'Autre expérience' ? _c('div', {
          staticClass: "bg-white grid grid-cols-12 gap-x-4 gap-y-10"
        }, [_c('input-text', {
          staticClass: "col-start-1 md:col-span-6",
          attrs: {
            "error": true,
            "maxlength": 50,
            "necessary": true,
            "value": item.value.intitule_parcours,
            "libelle": "Intitulé de l'expérience",
            "name": "intitule_parcours"
          },
          on: {
            "input": function (newValue) {
              item.value.intitule_parcours = newValue;
            }
          }
        }), _vm._v(" "), _c('date-picker', {
          staticClass: "col-span-full md:col-start-1 md:col-span-3",
          attrs: {
            "necessary-date": true,
            "value": item.value.debut_parcours,
            "format": "dd/MM/yyyy",
            "initialview": "year",
            "libelle": "Début",
            "name": "debut_parcours"
          },
          on: {
            "input": function (newValue) {
              if (item.value.fin_parcours === '' || _vm.$verifyDates({
                debut: newValue,
                fin: item.value.fin_parcours
              })) {
                item.value.debut_parcours = newValue;
              } else {
                _vm.badDates();
              }
              _vm.sortParcours();
            }
          }
        }), _vm._v(" "), _c('date-picker', {
          staticClass: "col-span-full md:col-span-3",
          attrs: {
            "necessary-date": true,
            "value": item.value.fin_parcours,
            "format": "dd/MM/yyyy",
            "initialview": "year",
            "libelle": "Fin",
            "name": "fin_parcours"
          },
          on: {
            "input": function (newValue) {
              if (item.value.debut_parcours === '' || _vm.$verifyDates({
                debut: item.value.debut_parcours,
                fin: newValue
              })) {
                item.value.fin_parcours = newValue;
              } else {
                _vm.badDates();
              }
            }
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "col-start-1 md:col-span-3",
          attrs: {
            "necessary": true,
            "value": item.value.structure_accueil_parcours,
            "libelle": "Nom de la structure d'accueil",
            "name": "structure_accueil_parcours"
          },
          on: {
            "input": function (newValue) {
              item.value.structure_accueil_parcours = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "necessary": true,
            "value": item.value.localisation_parcours,
            "libelle": "Localisation",
            "name": "localisation_parcours"
          },
          on: {
            "input": function (newValue) {
              item.value.localisation_parcours = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text-area', {
          staticClass: "lg:col-start-1 md:col-span-6",
          attrs: {
            "necessary": true,
            "value": item.value.aborde_parcours,
            "libelle": "Les activités abordées",
            "name": "aborde_parcours"
          },
          on: {
            "input": function (newValue) {
              item.value.aborde_parcours = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text-area', {
          staticClass: "md:col-span-6",
          attrs: {
            "value": item.value.commentaires_parcours,
            "libelle": "Commentaires",
            "name": "commentaires_parcours"
          },
          on: {
            "input": function (newValue) {
              item.value.commentaires_parcours = newValue;
            }
          }
        }), _vm._v(" "), _c('h4', {
          staticClass: "col-span-full text-gray-600 my-10"
        }, [_vm._v("\n              Les compétences mobilisées\n            ")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-full md:col-span-4"
        }, [_c('div', {
          staticClass: "block"
        }, [_c('label', {
          staticClass: "text-base text-gray-900 font-medium"
        }, [_vm._v("Pratiques\n                  professionnelles")]), _vm._v(" "), _c('em', {
          staticClass: "block text-sm text-gray-600"
        }, [_c('info-bulle', {
          attrs: {
            "is-libelle-input": true,
            "libelle": "Ensemble des moyens (connaissances et informations techniques, habilité pratique...) qui permettent l’accomplissement d’une tâche.",
            "name": "pratiques_pro"
          },
          scopedSlots: _vm._u([{
            key: "libelleBefore",
            fn: function () {
              return [_vm._v("\n                      être capable de...\n                    ")];
            },
            proxy: true
          }], null, true)
        })], 1)]), _vm._v(" "), _vm._l(item.value.pratiques, function (pratique, i) {
          return _c('div', {
            key: i,
            staticClass: "flex content-center lg:pr-10 pt-5"
          }, [_c('delete-button', {
            staticClass: "md:pt-2",
            on: {
              "del": function ($event) {
                return _vm.deleteItem(item.value.pratiques, i);
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "px-4",
            attrs: {
              "necessary": true,
              "value": pratique.value,
              "libelle": "",
              "name": "pratiques"
            },
            on: {
              "input": function (newValue) {
                pratique.value = newValue;
              }
            }
          })], 1);
        }), _vm._v(" "), _c('add-button', {
          staticClass: "mt-5",
          attrs: {
            "libelle": "Ajouter une pratique"
          },
          on: {
            "add": function ($event) {
              return _vm.addItem('competences', item.value.pratiques);
            }
          }
        })], 2), _vm._v(" "), _c('div', {
          staticClass: "col-span-full md:col-span-4"
        }, [_c('div', {
          staticClass: "block"
        }, [_c('label', {
          staticClass: "text-base text-gray-900 font-medium"
        }, [_vm._v("Connaissances associées")]), _vm._v(" "), _c('em', {
          staticClass: "block text-sm text-gray-600"
        }, [_c('info-bulle', {
          attrs: {
            "is-libelle-input": true,
            "libelle": "Ensemble des savoirs théoriques, techniques et pratiques acquis par l’étude (formation initiale ou professionnelle) ou l’expérience.",
            "name": "connaissances_pro"
          },
          scopedSlots: _vm._u([{
            key: "libelleBefore",
            fn: function () {
              return [_vm._v("\n                      Théoriques, procédurales...\n                    ")];
            },
            proxy: true
          }], null, true)
        })], 1)]), _vm._v(" "), _vm._l(item.value.connaissances, function (connaissance, i) {
          return _c('div', {
            key: i,
            staticClass: "flex content-center lg:pr-10 pt-5"
          }, [_c('delete-button', {
            staticClass: "md:pt-2",
            on: {
              "del": function ($event) {
                return _vm.deleteItem(item.value.connaissances, i);
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "px-4",
            attrs: {
              "necessary": true,
              "value": connaissance.value,
              "libelle": "",
              "name": "connaissances"
            },
            on: {
              "input": function (newValue) {
                connaissance.value = newValue;
              }
            }
          })], 1);
        }), _vm._v(" "), _c('add-button', {
          staticClass: "mt-5",
          attrs: {
            "libelle": "Ajouter une connaissance"
          },
          on: {
            "add": function ($event) {
              return _vm.addItem('competences', item.value.connaissances);
            }
          }
        })], 2), _vm._v(" "), _c('div', {
          staticClass: "col-span-full md:col-span-4"
        }, [_c('div', {
          staticClass: "block"
        }, [_c('label', {
          staticClass: "text-base text-gray-900 font-medium"
        }, [_c('info-bulle', {
          attrs: {
            "size-less": true,
            "libelle": "Capacité de produire des actions et des réactions adaptées à l’environnement humain.",
            "name": "comportements_pro"
          },
          scopedSlots: _vm._u([{
            key: "libelleBefore",
            fn: function () {
              return [_vm._v("\n                      Comportements / aptitudes\n                    ")];
            },
            proxy: true
          }], null, true)
        })], 1), _vm._v(" "), _c('em', {
          staticClass: "block text-sm text-gray-600"
        }, [_c('br')])]), _vm._v(" "), _vm._l(item.value.comportements, function (comportement, i) {
          return _c('div', {
            key: i,
            staticClass: "flex content-center lg:pr-10 pt-5"
          }, [_c('delete-button', {
            staticClass: "md:pt-2",
            on: {
              "del": function ($event) {
                return _vm.deleteItem(item.value.comportements, i);
              }
            }
          }), _vm._v(" "), _c('input-text', {
            staticClass: "px-4",
            attrs: {
              "necessary": true,
              "value": comportement.value,
              "libelle": "",
              "name": "comportements"
            },
            on: {
              "input": function (newValue) {
                comportement.value = newValue;
              }
            }
          })], 1);
        }), _vm._v(" "), _c('add-button', {
          staticClass: "mt-5",
          attrs: {
            "libelle": "Ajouter une aptitude"
          },
          on: {
            "add": function ($event) {
              return _vm.addItem('competences', item.value.comportements);
            }
          }
        })], 2), _vm._v(" "), _c('delete-button', {
          staticClass: "col-span-full",
          attrs: {
            "libelle": "Supprimer ce parcours"
          },
          on: {
            "del": function ($event) {
              return _vm.deleteItem(_vm.form.parcours, num);
            }
          }
        })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.parcoursDisplayed === num,
            expression: "parcoursDisplayed === num"
          }],
          key: 'stageproj' + num,
          attrs: {
            "id": `periode${num}`
          }
        }, [item.type === 'Stage' && item.projet ? _c('div', {
          staticClass: "bg-white px-5 pt-5 md:px-15 md:pt-15 grid grid-cols-12 gap-x-4 gap-y-10"
        }, [_c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "intitule_periode",
            "necessary": true,
            "libelle": "Intitulé du stage",
            "value": item.intitule_periode,
            "disabled": ""
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "nom_structure",
            "necessary": true,
            "libelle": "Nom de la structure d'accueil",
            "value": item.nom_structure,
            "disabled": ""
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "localisation_stage",
            "necessary": true,
            "libelle": "Localisation",
            "value": item.localisation_stage,
            "disabled": ""
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "referent_stage",
            "necessary": true,
            "libelle": "Référent / interlocuteur principal",
            "value": item.referent_stage,
            "disabled": ""
          }
        }), _vm._v(" "), _c('date-picker', {
          staticClass: "col-span-full md:col-span-3",
          attrs: {
            "name": "debut_periode",
            "necessary-date": true,
            "libelle": "Date de début du stage",
            "format": "dd/MM/yyyy",
            "initialview": "year",
            "value": item.debut_periode,
            "disabled": true
          }
        }), _vm._v(" "), _c('date-picker', {
          staticClass: "col-span-full md:col-span-3",
          attrs: {
            "name": "fin_periode",
            "necessary-date": true,
            "libelle": "Date de fin du stage",
            "format": "dd/MM/yyyy",
            "initialview": "year",
            "value": item.fin_periode,
            "disabled": true
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "duree_stage",
            "necessary": true,
            "libelle": "Durée (en h)",
            "value": item.duree_stage,
            "disabled": ""
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "type_stage",
            "necessary": true,
            "libelle": "Type de stage",
            "size": "3",
            "value": item.type_stage,
            "disabled": ""
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "milieu_stage",
            "necessary": true,
            "libelle": "Stage en milieu",
            "size": "3",
            "value": item.milieu_stage,
            "disabled": ""
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "caracteristique_stage",
            "necessary": true,
            "libelle": "Caracteristiques du stage",
            "size": "3",
            "value": item.caracteristique_stage,
            "disabled": ""
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "etat_decision",
            "necessary": true,
            "libelle": "Etat de la décision",
            "size": "3",
            "value": item.etat_decision,
            "disabled": ""
          }
        }), _vm._v(" "), _c('input-text-area', {
          staticClass: "lg:col-start-1 md:col-span-6",
          attrs: {
            "name": "objectifs_resultats",
            "necessary": true,
            "libelle": "Objectifs / Résultats attendus",
            "size": "4",
            "value": item.objectifs_resultats,
            "disabled": ""
          }
        }), _vm._v(" "), _c('input-text-area', {
          staticClass: "md:col-span-6",
          attrs: {
            "name": "commentaire_stage",
            "libelle": "Commentaires",
            "size": "4",
            "value": item.commentaire_stage,
            "disabled": ""
          }
        })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.parcoursDisplayed === num,
            expression: "parcoursDisplayed === num"
          }],
          key: 'formation' + num
        }, [item.type === 'Formation' && item.projet ? _c('div', {
          staticClass: "bg-white p-5 md:p-15 grid grid-cols-12 gap-x-4 gap-y-10"
        }, [_c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "intitule_periode",
            "necessary": true,
            "libelle": "Intitulé de la formation",
            "value": item.intitule_periode,
            "disabled": ""
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "organisme_formation",
            "necessary": true,
            "libelle": "Organisme de formation",
            "value": item.organisme_formation,
            "disabled": ""
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "localisation_formation",
            "necessary": true,
            "libelle": "Localisation",
            "value": item.localisation_formation,
            "disabled": ""
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "referent_formation",
            "necessary": true,
            "libelle": "Référent / Interlocuteur principal",
            "value": item.referent_formation,
            "disabled": ""
          }
        }), _vm._v(" "), _c('date-picker', {
          staticClass: "col-span-full md:col-span-3",
          attrs: {
            "name": "debut_periode",
            "necessary-date": true,
            "libelle": "Date de début de formation",
            "format": "dd/MM/yyyy",
            "initialview": "year",
            "value": item.debut_periode,
            "disabled": true
          }
        }), _vm._v(" "), _c('date-picker', {
          staticClass: "col-span-full md:col-span-3",
          attrs: {
            "name": "fin_periode",
            "necessary-date": true,
            "libelle": "Date de fin de formation",
            "format": "dd/MM/yyyy",
            "initialview": "year",
            "value": item.fin_periode,
            "disabled": true
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "duree_formation",
            "necessary": true,
            "libelle": "durée (en h)",
            "value": item.duree_formation,
            "disabled": ""
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "type_formation",
            "necessary": true,
            "libelle": "Type de formation",
            "value": item.type_formation,
            "disabled": ""
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "modalites_formation",
            "necessary": true,
            "libelle": "Modalités",
            "value": item.modalites_formation,
            "disabled": ""
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "dispositifs_formation",
            "necessary": true,
            "libelle": "Dispositifs retenus",
            "value": item.dispositifs_formation,
            "disabled": ""
          }
        }), _vm._v(" "), _c('transition', {
          attrs: {
            "enter-active-class": "ease-in duration-300",
            "enter-class": "opacity-0",
            "leave-active-class": "ease-out duration-300",
            "leave-to-class": "opacity-0"
          }
        }, [item.dispositifs_formation === 'Autres' ? _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "dispositifs_formation_precis",
            "necessary": true,
            "libelle": "Précisez (si autre)",
            "value": item.dispositifs_formation_precis,
            "disabled": ""
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "formation_suivie",
            "necessary": true,
            "libelle": "Formation suivie au titre de",
            "value": item.formation_suivie,
            "disabled": ""
          }
        }), _vm._v(" "), _c('transition', {
          attrs: {
            "enter-active-class": "ease-in duration-300",
            "enter-class": "opacity-0",
            "leave-active-class": "ease-out duration-300",
            "leave-to-class": "opacity-0"
          }
        }, [item.formation_suivie === 'Autre' ? _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "necessary": true,
            "name": "dispositifs_formation_precis",
            "libelle": "Précisez (si autre)",
            "value": item.formation_suivie_precis,
            "disabled": ""
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "etat_decision",
            "necessary": true,
            "libelle": "Etat de la décision",
            "value": item.etat_decision,
            "disabled": ""
          }
        }), _vm._v(" "), _c('input-text-area', {
          staticClass: "lg:col-start-1 md:col-span-6",
          attrs: {
            "name": "objectifs_formation",
            "necessary": true,
            "libelle": "Objectifs pédagogiques",
            "size": "4",
            "value": item.objectifs_formation,
            "disabled": ""
          }
        }), _vm._v(" "), _c('input-text-area', {
          staticClass: "md:col-span-6",
          attrs: {
            "name": "commentaire_formation",
            "libelle": "Commentaires",
            "size": "4",
            "value": item.commentaire_formation,
            "disabled": ""
          }
        })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: _vm.parcoursDisplayed === num,
            expression: "parcoursDisplayed === num"
          }],
          key: 'accompagnement' + num
        }, [item.type === 'Accompagnement' && item.projet ? _c('div', {
          staticClass: "bg-white p-5 md:p-15 grid grid-cols-12 gap-x-4 gap-y-10"
        }, [_c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "intitule_periode",
            "necessary": true,
            "libelle": "Intitulé",
            "value": item.intitule_periode,
            "disabled": ""
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "organisme_accompagnement",
            "necessary": true,
            "libelle": "Organisme",
            "value": item.organisme_accompagnement,
            "disabled": ""
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "localisation_accompagnement",
            "necessary": true,
            "libelle": "Localisation",
            "value": item.localisation_accompagnement,
            "disabled": ""
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "referent_accompagnement",
            "necessary": true,
            "libelle": "Référent / Interlocuteur principal",
            "value": item.referent_accompagnement,
            "disabled": ""
          }
        }), _vm._v(" "), _c('date-picker', {
          staticClass: "col-span-full md:col-span-3",
          attrs: {
            "name": "debut_periode",
            "necessary-date": true,
            "libelle": "Date de début de l'accompagnement",
            "format": "dd/MM/yyyy",
            "initialview": "year",
            "value": item.debut_periode,
            "disabled": true
          }
        }), _vm._v(" "), _c('date-picker', {
          staticClass: "col-span-full md:col-span-3",
          attrs: {
            "name": "fin_periode",
            "necessary-date": true,
            "libelle": "Date de fin de l'accompagnement",
            "format": "dd/MM/yyyy",
            "initialview": "year",
            "value": item.fin_periode,
            "disabled": true
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "duree_accompagnement",
            "necessary": true,
            "libelle": "durée (en h)",
            "value": item.duree_accompagnement,
            "disabled": ""
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "type_accompagnement",
            "necessary": true,
            "libelle": "Type d'accompagnement",
            "value": item.type_accompagnement,
            "disabled": ""
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "modalites_accompagnement",
            "necessary": true,
            "libelle": "Modalités",
            "value": item.modalites_accompagnement,
            "disabled": ""
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "dispositifs_accompagnement",
            "necessary": true,
            "libelle": "Dispositifs retenus",
            "value": item.dispositifs_accompagnement,
            "disabled": ""
          }
        }), _vm._v(" "), _c('transition', {
          attrs: {
            "enter-active-class": "ease-in duration-300",
            "enter-class": "opacity-0",
            "leave-active-class": "ease-out duration-300",
            "leave-to-class": "opacity-0"
          }
        }, [item.dispositifs_accompagnement === 'Autres' ? _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "dispositifs_accompagnement_precis",
            "necessary": true,
            "libelle": "Précisez (si autre)",
            "value": item.dispositifs_accompagnement_precis,
            "disabled": ""
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-3",
          attrs: {
            "name": "etat_decision",
            "necessary": true,
            "libelle": "Etat de la décision",
            "value": item.etat_decision,
            "disabled": ""
          }
        }), _vm._v(" "), _c('input-text-area', {
          staticClass: "lg:col-start-1 md:col-span-6",
          attrs: {
            "name": "objectifs_accompagnement",
            "necessary": true,
            "libelle": "Objectifs pédagogiques",
            "size": "4",
            "value": item.objectifs_accompagnement,
            "disabled": ""
          }
        }), _vm._v(" "), _c('input-text-area', {
          staticClass: "md:col-span-6",
          attrs: {
            "name": "commentaire_accompagnement",
            "libelle": "Commentaires",
            "size": "4",
            "value": item.commentaire_accompagnement,
            "disabled": ""
          }
        })], 1) : _vm._e()])];
      }
    }], null, false, 2227392831)
  })], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }